import { ref } from 'vue';
import type { GetterTree, MutationTree } from 'vuex';
import type { RootState } from '@/types/store-types';

export type Staggered = {
  amount: number;
  percentage: number;
};

export type Rebate = {
  name?: string; // not used
  description?: string | undefined; // Visible as badge text
  footnote?: string;
  staggereds?: Staggered[];
};

export type Rebates = Record<string, Rebate>;

export interface OfferState {
  rebates: Rebates;
  zeroPercentFinancing: string[];
  compaEanList: string[];
}

interface OfferGettersTypes {
  rebates: Rebates;
  zeroPercentFinancing: string[];
}

export type OfferGetterTree = {
  [P in keyof OfferGettersTypes]: OfferGettersTypes[P];
};

export type OfferGetters = {
  [P in keyof OfferGettersTypes]: (
    state: OfferState,
    getters: OfferGetterTree
  ) => OfferGettersTypes[P];
};

// We use the Staggered rebates. But they cannot be combined with Coupons. So we need to add the texte by hand.
export const manualRebates = ref<Rebates>({
  // https://i22-telekom-longtail.atlassian.net/browse/LT-1842#icft=LT-1842
  '4251281685165': {
    name: 'Schwaiger Bundel Code',
    description: 'Mit dem Code SONNE100 sparst du 100 €.',
    footnote:
      'Volle Power für deinen Balkon – mit 100€ Rabatt. Gibt den Code SONNE100 im Warenkorb ein und erhalte 100 € Rabatt auf das Set. ',
  },
});

export const state = (): OfferState => ({
  rebates: {},
  zeroPercentFinancing: [],
  compaEanList: [],
});

export const mutations: MutationTree<OfferState> = {
  SET_REBATES(state, rebates: Rebates) {
    state.rebates = { ...rebates, ...manualRebates.value };
  },
  SET_ZERO_PERCENT_FINANCING(state, articleNumbers: string[]) {
    state.zeroPercentFinancing = articleNumbers;
  },
  SET_COMPA_EAN_LIST(state, compaEanList: string[]) {
    state.compaEanList = compaEanList;
  },
};

export const getters: GetterTree<OfferState, RootState> & OfferGetters = {
  rebates(state) {
    return state.rebates;
  },
  zeroPercentFinancing(state) {
    return state.zeroPercentFinancing;
  },
  compaEanList(state) {
    return state.compaEanList;
  },
};
